import {observer} from 'mobx-react';
import React from 'react';
import {LanguageListStore} from '../LanguageListStore';

@observer
export class EditLanguageForm extends React.Component<{ store: LanguageListStore }> {
  render() {
    const {store} = this.props;

    if (store.editLanguage === null)
      return null;

    const name = store.editLanguage.name;
    return (
      <div className="row">
        <div className="col">
          <div className={name.formGroupClassName}>
            <input className="form-control" type="text"
                   value={name.value}
                   onChange={name.onChangeHandler}
                   onKeyDown={store.completeOnEnter}
                   onBlur={name.markTouched}/>
            <div className="invalid-text">Enter name</div>
          </div>
        </div>
      </div>);
  }
}
